import React from "react";
import { DraggableProvidedDragHandleProps } from "react-beautiful-dnd";
import FilterNoneIcon from "@material-ui/icons/FilterNone";
import SvgI24Details from "assets/icons/I24Details";
import SvgI24Edit from "assets/icons/I24Edit";
import SvgI24Archive from "assets/icons/I24Archive";
import SvgI24Menu from "assets/icons/I24Menu";
import { Button, Typography } from "@material-ui/core";
import PublishStatus from "components/PublishStatus";
import TrimmedText from "components/TrimmedText";
import { getPublishButtonText, getPublishButtonIcon } from "utils/publish";
import {
  Container,
  ImageContainer,
  DetailsContainer,
  TextContainer,
  TitleWrapper,
  BottomControlsContainer,
  ControlWrapper,
  MenuContent,
  MenuContentWrapper,
  Menu,
} from "./styles";

type Props = {
  title: string;
  subtitle?: string;
  note?: string;
  image: string;
  publishStatus: string;
  isDragging?: boolean;
  onEdit: () => void;
  onCopy?: () => void;
  onDetailsClick: () => void;
  onPublish: () => void;
  onArchive: () => void;
  dragHandleProps?: DraggableProvidedDragHandleProps;
};

class CategoryCard extends React.Component<Props> {
  render() {
    const {
      title,
      subtitle,
      note,
      image,
      publishStatus,
      dragHandleProps,
      isDragging,
      onEdit,
      onCopy,
      onDetailsClick,
      onPublish,
      onArchive,
    } = this.props;

    return (
      <Container isDragging={isDragging}>
        <ImageContainer image={image} />
        <DetailsContainer>
          <TextContainer>
            <TitleWrapper>
              <TrimmedText lines={1} text={title}>
                <Typography variant="h3" color="textPrimary">
                  {title}
                </Typography>
              </TrimmedText>
            </TitleWrapper>
            <TrimmedText lines={1} text={subtitle}>
              <Typography variant="subtitle1" color="secondary">
                {subtitle}
              </Typography>
            </TrimmedText>
            <TrimmedText lines={1} text={note}>
              <Typography variant="subtitle1" color="primary">
                {note}
              </Typography>
            </TrimmedText>
          </TextContainer>
          <BottomControlsContainer>
            <ControlWrapper>
              <Button
                startIcon={<SvgI24Details />}
                variant="text"
                color="secondary"
                onClick={onDetailsClick}
              >
                Details
              </Button>
            </ControlWrapper>
            <ControlWrapper>
              <Button
                startIcon={<SvgI24Edit />}
                variant="text"
                color="secondary"
                onClick={onEdit}
              >
                Edit
              </Button>
            </ControlWrapper>
            <ControlWrapper>
              {onCopy && (
                <Button
                  startIcon={<FilterNoneIcon />}
                  variant="text"
                  color="secondary"
                  onClick={onCopy}
                >
                  Copy
                </Button>
              )}
            </ControlWrapper>
            <ControlWrapper>
              <Button
                startIcon={<SvgI24Archive />}
                variant="text"
                color="secondary"
                onClick={onArchive}
              >
                Archive
              </Button>
            </ControlWrapper>
            <ControlWrapper>
              <Button
                startIcon={getPublishButtonIcon(publishStatus)}
                variant="text"
                color="secondary"
                onClick={onPublish}
              >
                {getPublishButtonText(publishStatus)}
              </Button>
            </ControlWrapper>
          </BottomControlsContainer>
        </DetailsContainer>
        <MenuContent>
          <MenuContentWrapper>
            <PublishStatus status={publishStatus} />
          </MenuContentWrapper>
          {dragHandleProps && (
            <MenuContentWrapper>
              <Menu {...dragHandleProps}>
                <SvgI24Menu />
              </Menu>
            </MenuContentWrapper>
          )}
        </MenuContent>
      </Container>
    );
  }
}

export default CategoryCard;
